/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bright_Gray_Goat_BaskInputs */

const en_bright_gray_goat_bask = /** @type {(inputs: Bright_Gray_Goat_BaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculating values and KPIs for all segments.`)
};

const de_bright_gray_goat_bask = /** @type {(inputs: Bright_Gray_Goat_BaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werte und KPIs werden für alle Segmente berechnet.`)
};

/**
* | output |
* | --- |
* | "Calculating values and KPIs for all segments." |
*
* @param {Bright_Gray_Goat_BaskInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bright_gray_goat_bask = /** @type {((inputs?: Bright_Gray_Goat_BaskInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bright_Gray_Goat_BaskInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bright_gray_goat_bask(inputs)
	return de_bright_gray_goat_bask(inputs)
});